

<div  *ngIf="!disabled" placeholder="Enter Web Answer" #editorContainer></div>


<textarea *ngIf="disabled" class="form-control" rows="4"
    [(ngModel)]="value"></textarea>
